// The original hardcoded YouTube videos/shorts, kept here so the seller can
// one-time import them into Firestore after the Videos page moved off static data.
export const ORIGINAL_YOUTUBE_VIDEOS = [
    { title: 'Sambalpuri Fashion Collection', url: 'https://www.youtube.com/watch?v=Tq27C-w_SuQ', category: 'video' },
    { title: 'Traditional Wear Styling', url: 'https://www.youtube.com/watch?v=FzlBp-uKtv0', category: 'video' },
    { title: 'Latest Fashion Trends', url: 'https://www.youtube.com/watch?v=HvpSRQqw1n8', category: 'video' },
    { title: 'Sambalpuri Saree Collection', url: 'https://www.youtube.com/shorts/Zaovg2Wx6WQ', category: 'short' },
    { title: 'Handloom Weaving Showcase', url: 'https://www.youtube.com/shorts/KLulwt0GxUg', category: 'short' },
    { title: 'Sambalpuri Kurti Showcase', url: 'https://www.youtube.com/shorts/beu896gBASI', category: 'short' }
];
